import { render } from "./RatioTable.vue?vue&type=template&id=2ed94aaf&scoped=true"
import script from "./RatioTable.vue?vue&type=script&lang=js"
export * from "./RatioTable.vue?vue&type=script&lang=js"

import "./RatioTable.vue?vue&type=style&index=0&id=2ed94aaf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed94aaf"]])

export default __exports__